export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_go_to_my_orders',
    defaultMessage: 'Go to My orders',
  },
}
